// extracted by mini-css-extract-plugin
module.exports = {"category":"DpCLVw9W","icon":"_7ppxNd0A","title":"VYHWi5a5"};